import { clone, findIndex } from 'es-toolkit/compat';

import { IconButton } from 'omakase';
import { IconCrossLarge } from '@tock/icons';

export interface Item<T> {
  key: string | number;
  value: T;
}

interface Props<T> {
  generateInnerComponent(option: Item<T>): JSX.Element;
  items: Item<T>[];
  onChange(selectedOptions: T[]): void;
}

function RemoveListOptions<T>({ generateInnerComponent, items, onChange }: Props<T>) {
  const handleRemoveitem = (key: string | number) => {
    const itemsClone = clone(items);
    itemsClone.splice(
      findIndex(itemsClone, (item) => item.key === key),
      1
    );
    onChange(itemsClone.map((item) => item.value));
  };

  return (
    <div className="RemoveListOptions">
      {items.map((item) => {
        const itemComponent = generateInnerComponent(item);
        return (
          <RemoveListOptionsItem
            key={item.key}
            item={item}
            onRemove={handleRemoveitem}
            itemComponent={itemComponent}
          />
        );
      })}
    </div>
  );
}

export default RemoveListOptions;

interface RemoveListOptionsItemProps<T> {
  itemComponent: JSX.Element;
  item: Item<T>;
  modifierClassName?: string;
  onRemove(key: string | number): void;
}

function RemoveListOptionsItem<T>({
  itemComponent,
  item,
  onRemove,
}: RemoveListOptionsItemProps<T>) {
  const handleClickRemove = () => {
    onRemove(item.key);
  };

  return (
    <div className="RemoveListOption-item">
      {itemComponent}
      <div className="RemoveListOptions-item-remove">
        <IconButton
          variant="highContrast"
          aria-label="Remove option"
          size="xsmall"
          onClick={handleClickRemove}
        >
          <IconCrossLarge />
        </IconButton>
      </div>
    </div>
  );
}
